import type { HorizontalAlign } from "../align/HorizontalAlign"
import type { VerticalAlign } from "../align/VerticalAlign"
import type { BlobMap } from "./BlobMap"
import type { ColorMap } from "./ColorMap"
import type { ScaleMap } from "./ScaleMap"

export type PlottingContext = Partial<{
  readonly color_map: ColorMap
  readonly file_map: BlobMap
  readonly scale_map: ScaleMap
  readonly unit_to_px: number
  readonly bleed: number
  readonly stroke_width: number
  readonly font_size: number
  readonly font_path: string
  readonly font_family: string
  readonly font_height_adjustment: number
  readonly image_resolution: number
  readonly horizontal_align: HorizontalAlign
  readonly vertical_align: VerticalAlign
}>
